<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read analysis'">
      <template #gated-content>
        <analysis-card :analysis="analysis" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/analysis/${analysis_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="analysis"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="analysis"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AnalysisCard from '@/components/lab/analysis/AnalysisCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import AnalysisModel from '@/models/lab/AnalysisModel'

export default {
  name: "AnalysisAuditTrail",
  components: {
    PermissionAlertGate,
    AnalysisCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      analysis: null,
      analysis_id: this.$route.params.analysis_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/analysis/${this.analysis_id}`,
            title: "View analysis",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.analysis = new AnalysisModel({ id: this.analysis_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.analysis.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
